import axios from 'axios';
import { PROPERTIES as MOCK_PROPERTIES } from '../data/mock';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Fetch all properties (optionally filtered). Falls back to local mock on failure.
export async function fetchProperties(params = {}) {
  try {
    const res = await axios.get(`${API}/properties`, { params, timeout: 12000 });
    if (Array.isArray(res.data) && res.data.length > 0) return res.data;
    return MOCK_PROPERTIES;
  } catch (e) {
    console.warn('fetchProperties fallback to mock:', e.message);
    return MOCK_PROPERTIES;
  }
}

// Fetch a single property by id. Falls back to local mock.
export async function fetchProperty(id) {
  try {
    const res = await axios.get(`${API}/properties/${id}`, { timeout: 12000 });
    return res.data;
  } catch (e) {
    console.warn('fetchProperty fallback to mock:', e.message);
    return MOCK_PROPERTIES.find((p) => p.id === id) || null;
  }
}

// Submit a contact enquiry.
export async function submitEnquiry(payload) {
  const res = await axios.post(`${API}/contact`, payload, { timeout: 15000 });
  return res.data;
}

// ---------------- Admin ----------------
const authHeader = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export async function adminLogin(username, password) {
  const res = await axios.post(`${API}/admin/login`, { username, password });
  return res.data; // { token, username }
}

export async function adminVerify(token) {
  const res = await axios.get(`${API}/admin/me`, authHeader(token));
  return res.data;
}

export async function adminListEnquiries(token) {
  const res = await axios.get(`${API}/contact`, authHeader(token));
  return res.data;
}

export async function adminCreateProperty(token, property) {
  const res = await axios.post(`${API}/admin/properties`, property, authHeader(token));
  return res.data;
}

export async function adminUpdateProperty(token, id, property) {
  const res = await axios.put(`${API}/admin/properties/${id}`, property, authHeader(token));
  return res.data;
}

export async function adminDeleteProperty(token, id) {
  const res = await axios.delete(`${API}/admin/properties/${id}`, authHeader(token));
  return res.data;
}

export async function adminToggleFeatured(token, id, featured) {
  const res = await axios.patch(`${API}/admin/properties/${id}/featured`, { featured }, authHeader(token));
  return res.data;
}

export async function adminUploadImage(token, file) {
  const fd = new FormData();
  fd.append('file', file);
  const res = await axios.post(`${API}/admin/upload`, fd, {
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
    timeout: 30000,
  });
  return res.data; // { url }
}

export async function adminChangeCredentials(token, payload) {
  const res = await axios.post(`${API}/admin/change-credentials`, payload, authHeader(token));
  return res.data; // { token, username }
}

export async function getSiteContent() {
  const res = await axios.get(`${API}/site-content`, { timeout: 12000 });
  return res.data; // { overrides }
}

export async function adminSaveSiteContent(token, overrides) {
  const res = await axios.put(`${API}/admin/site-content`, { overrides }, authHeader(token));
  return res.data;
}
